import { render, staticRenderFns } from "./AlgorithmSeting.vue?vue&type=template&id=e310f102&scoped=true"
import script from "./AlgorithmSeting.vue?vue&type=script&lang=js"
export * from "./AlgorithmSeting.vue?vue&type=script&lang=js"
import style0 from "./AlgorithmSeting.vue?vue&type=style&index=0&id=e310f102&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e310f102",
  null
  
)

export default component.exports